export { default as GeneralLayout } from "./GeneralLayout";
